
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import recruit from "@/assets/data/recruit/recruit.json";
import PageHero from "@/components/UI/renewal/PageHero.vue";
import CtaSection from "@/components/UI/renewal/CtaSection.vue";
import BrandButton from "@/components/UI/renewal/BrandButton.vue";

// recruit.json の構造
// type でレイアウトを振り分ける(タイトル文言の変更に強い)
type RecruitItemType = "background" | "duties" | "qualification" | "flow" | "spec";
interface RecruitSection {
  description?: string;
  points: string[];
  listStyle: string;
  contents: string[];
  listContents?: string[];
}
interface RecruitItem {
  title: string;
  type: RecruitItemType;
  description?: string;
  sections: RecruitSection[];
}

// 募集要項カードのアイコン(タイトル別。未定義でも汎用アイコンにフォールバック)
const SPEC_ICONS: Record<string, string> = {
  "会社所在地": "mdi-map-marker-outline",
  "雇用形態": "mdi-badge-account-horizontal-outline",
  "給与": "mdi-cash-multiple",
  "勤務時間": "mdi-clock-outline",
  "休日休暇": "mdi-calendar-check-outline",
  "福利厚生": "mdi-gift-outline",
};

@Component({
  components: {PageHero, CtaSection, BrandButton}
})
export default class RecruitContent extends Vue {
  private items: RecruitItem[] = recruit.items as RecruitItem[];

  private background = this.items.find((i) => i.type === "background");
  private duties = this.items.find((i) => i.type === "duties");
  private qualification = this.items.find((i) => i.type === "qualification");
  private flow = this.items.find((i) => i.type === "flow");
  private specs = this.items.filter((i) => i.type === "spec");

  private flowLead: string = this.flow?.sections[0]?.points[0] ?? "";
  private flowSteps: string[] = this.flow?.sections[0]?.contents ?? [];

  private ctaLead: string = recruit.footer.contents.join("<br/>");
  private applyButton = recruit.footer.buttons.find((b) => b.label.includes("応募"));
  private wantedlyButton = recruit.footer.buttons.find((b) => b.label.includes("Wantedly"));

  private specIcon(title: string): string {
    return SPEC_ICONS[title] ?? "mdi-file-document-outline";
  }

  private isNote(text: string): boolean {
    return text.startsWith("※");
  }
}
